import { useEffect, useState } from "react";

type McpState = "unknown" | "ok" | "degraded";

interface HealthResponse {
  mcp?: { connected?: boolean; lastError?: string | null };
}

/** Polls /health every 60 s and reports MCP connectivity state. */
export function useMcpStatus(): McpState {
  const [state, setState] = useState<McpState>("unknown");

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const res = await fetch("/health", { cache: "no-store" });
        if (!res.ok) {
          if (!cancelled) setState("degraded");
          return;
        }
        const data: HealthResponse = await res.json();
        if (!cancelled) {
          setState(data.mcp?.connected === false ? "degraded" : "ok");
        }
      } catch {
        if (!cancelled) setState("degraded");
      }
    }

    void check();
    const id = setInterval(() => void check(), 60_000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, []);

  return state;
}
